import React from 'react'
import ComponentpediaLink, {ComponentpediaLinkTypes} from '../componentpedia';
import RegistryUrl from '../registry.url';
const ComponentCard = (props) => {

	const { index, url, library, name, displayName, version, scope, transitive, language, isLatest } = props;
	return (
		<div className="col-lg-8" id="dependency-list" data-language={language} data-lib={name + version}>
			<div className={"report-box dependency-inner" + (props.hasExclusions ? " dependency-inner-with-exclusions" : "")} id={`advice-${name + version}`} key={name + index}>
				<div className="report-box-header report-dependency">
					<div className="report-box-title">
						{isLatest ?
							<div className="text-link pr-1" value="" style={{ whiteSpace: "pre-wrap" }} title={`${name + ":" + version} See in dependency tree`}  
							tabIndex={0}
							onClick={() => { props.findDependencyInTree(language, name + " " + version) }}
							onKeyUp={(e) => { props.findDependencyInTree(language, name + " " + version, {key:e.key}) }} >{displayName + ":" + version}</div> :
							<div className="text-white pr-1" value="" >{displayName + ":" + version}</div>
						}
						<ComponentpediaLink class="advice-link mr-1" language={language} name={name} version={version} 
							type={ComponentpediaLinkTypes.SM} extraInfo={{unityPlugin: library.unityPlugin}}
						/>
						<RegistryUrl language={language} name={name} version={version} class={"advice-link mr-1"} extraInfo={{unityPlugin: library.unityPlugin}} />
						{scope ? <small className="badge badge-custom mr-1">{scope}</small> : ""}
						{transitive ? <small className="badge badge-custom badge-transitive mr-1">transitive</small> : ""}
					</div>
					<span className="hidden-xs">{language}  </span>
				</div>
				{props.children}
			</div>
		</div>
	)
}

export default ComponentCard